var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tg-nodata"},[_c('el-image',{style:(_vm.styleObj),attrs:{"src":_vm.noDataIcon}}),(_vm.breadcrumb)?_c('p',{staticStyle:{"padding-top":"20px"}},[_vm._v(_vm._s(_vm.breadcrumb))]):_vm._e(),_c('p',{staticStyle:{"padding-top":"20px"}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }